"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Heatmap = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var mobx_react_1 = require("mobx-react");
var PositionedSpinner_1 = require("../../ui/PositionedSpinner");
var Heatmap_model_1 = require("./Heatmap_model");
var HeatmapBody_view_1 = require("./HeatmapBody_view");
var HeatmapSidebar_view_1 = require("./HeatmapSidebar_view");
var HeatmapHeader_view_1 = require("./HeatmapHeader_view");
var react_1 = require("react");
var If_1 = require("../../hoc/If");
var createModel = function () {
    return new Heatmap_model_1.HeatmapModel();
};
var hasData = function (model) {
    return model.heatmapData && model.heatmapData.length !== 0;
};
var startUp = function (model, onRowClick, onCellClick, showValues, data) {
    if (data.heatmapRowData.length > 0) {
        model.setData(data);
        model.setImpactRange();
        model.setOnCellClick(onCellClick);
        model.setOnRowClick(onRowClick);
        model.setShowValues(showValues);
    }
};
//#endregion
var NoResultSelected = function (_a) {
    var label = _a.label;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "heatmap" }, { children: (0, jsx_runtime_1.jsx)("p", { children: label }) })));
};
var HeatmapWithData = (0, mobx_react_1.observer)(function (_a) {
    var model = _a.model;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "heatmap" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "heatmap__sidebar" }, { children: (0, jsx_runtime_1.jsx)(HeatmapSidebar_view_1.HeatmapSidebar, { model: model }) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "heatmap__content" }, { children: [(0, jsx_runtime_1.jsx)(HeatmapHeader_view_1.HeatmapHeader, { model: model }), (0, jsx_runtime_1.jsx)(HeatmapBody_view_1.HeatmapBody, { model: model })] }))] })));
});
var ShowSpinner = (0, mobx_react_1.observer)(function (_a) {
    var showIf = _a.showIf;
    return ((0, jsx_runtime_1.jsx)(If_1.IF, __assign({ condition: showIf }, { children: (0, jsx_runtime_1.jsx)(PositionedSpinner_1.PositionedSpinner, {}) })));
});
var ShowNoDataLabel = (0, mobx_react_1.observer)(function (_a) {
    var showIf = _a.showIf, label = _a.label;
    return ((0, jsx_runtime_1.jsx)(If_1.IF, __assign({ condition: showIf }, { children: (0, jsx_runtime_1.jsx)(NoResultSelected, { label: label }) })));
});
var ShowHeatmap = (0, mobx_react_1.observer)(function (_a) {
    var showIf = _a.showIf, model = _a.model;
    return ((0, jsx_runtime_1.jsx)(If_1.IF, __assign({ condition: showIf }, { children: (0, jsx_runtime_1.jsx)(HeatmapWithData, { model: model }) })));
});
var Heatmap = (0, mobx_react_1.observer)(function (_a) {
    var data = _a.data, showValues = _a.showValues, onRowClick = _a.onRowClick, onCellClick = _a.onCellClick, noDataLabel = _a.noDataLabel;
    var model = createModel();
    var _b = (0, react_1.useState)(true), isLoading = _b[0], setIsLoading = _b[1];
    (0, react_1.useEffect)(function () {
        model.onMount();
        setIsLoading(model.isLoading);
        return model.onUnmount();
    }, [model]);
    startUp(model, onRowClick, onCellClick, showValues, data);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "d-flex flex-row" }, { children: [(0, jsx_runtime_1.jsx)(ShowSpinner, { showIf: isLoading }), (0, jsx_runtime_1.jsx)(ShowNoDataLabel, { showIf: !isLoading && !hasData(model), label: noDataLabel }), (0, jsx_runtime_1.jsx)(ShowHeatmap, { showIf: !isLoading && hasData(model), model: model })] })));
});
exports.Heatmap = Heatmap;
